import { DataGrid } from '@innovyze/stylovyze';
import { styled } from '@mui/styles';

export const StyledMultiScoreDataGrid = styled(DataGrid)(() => ({
	height: '100%',
	width: '100%',
	'& .titleCell': {
		backgroundColor: '#f7f7f7',
		color: '#272833',
		fontWeight: '600',
		borderRight: '2px solid #e7e7ed',
	},
	'& .scoreCell': {
		borderLeft: '2px solid #e7e7ed',
	},
}));
